import { taskRailRoutes } from '@modules/Tasks/Resources/js/utils/taskRailRoutes';

export default {
    slug: 'equipment',
    ability: 'equipment',
    routes: [
        {
            path: 'equipment',
            name: 'equipment-list',
            component: () => import('@modules/Equipment/Resources/js/pages/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'equipment-preview',
                    component: () => import('@modules/Equipment/Resources/js/pages/Preview.vue'),
                    redirect: { name: 'equipment-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/equipment/:id(\\d+)',
                            name: 'equipment-overview',
                            component: () => import('@modules/Equipment/Resources/js/pages/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'tasks',
                            name: 'equipment-tasks',
                            component: () => import('@/components/base/tabs/TabTasks.vue'),
                            props: true,
                            children: taskRailRoutes('equipment-tasks')
                        },
                        {
                            path: 'comments',
                            name: 'equipment-comments',
                            component: () => import('@/components/base/tabs/TabComments.vue'),
                            props: true
                        },
                        {
                            path: 'activities',
                            name: 'equipment-activities',
                            component: () => import('@/components/base/tabs/TabActivities.vue'),
                            props: true
                        },
                        {
                            path: 'pictures',
                            name: 'equipment-pictures',
                            component: () => import('@/components/base/tabs/TabPictures.vue'),
                            props: true
                        },
                        {
                            path: 'logs',
                            name: 'equipment-logs',
                            component: () => import('@/components/base/tabs/TabLogs.vue'),
                            props: true
                        },
                        {
                            path: 'documents/:docPath(.*)*',
                            name: 'equipment-documents',
                            component: () => import('@/components/base/tabs/TabDocuments.vue'),
                            props: true
                        }
                    ]
                }
            ]
        }
    ],
    nav: () => ({
        section: 'inventory',
        items: [
            {
                title: i18n.t('Equipment'),
                icon: 'toolbox-outline',
                to: { name: 'equipment-list' }
            }
        ]
    })
};
